<template>

  <div class="companies">
    <v-progress-linear
      v-show="progressBar"
      slot="progress"
      color="blue"
      indeterminate
    />

    <confirm ref="confirm"></confirm>

     <v-container class="my-1">
      <v-layout row Wrap>
        <v-flex xs12 sm12 lg12
          ><v-card-text v-text="PageTitle" class="subtitle-1 grey--text">
          </v-card-text>
        </v-flex>
      </v-layout>

      <v-data-table
        :hide-default-footer="true"
        :disable-pagination="true"
        :disable-sort="true"
        :disable-filtering="true"
        :items="companies"
        :headers="headers"
        item-key="Company_ID"
        @click:row="gotocompany"
      >
        <template v-slot:top>
          <v-row>
            <v-flex xs6 sm6 lg6>
              <v-text-field
                v-model="companysearch"
                prepend-icon="mdi-magnify"
                clearable
              >
              </v-text-field>
            </v-flex>
            <v-flex xs1 sm1 lg1> </v-flex>

            <v-flex xs4 sm4 lg4 align-self-center>
              <div class="text-center d-flex align-center justify-space-around">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      @click="refreshlist"
                      medium
                      color="green darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-refresh
                    </v-icon>
                  </template>
                  <span>Refresh </span>
                </v-tooltip>

                <v-dialog v-model="filterdialog" max-width="600px" persistent>
                  <template v-slot:activator="{ on: dialog }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
                          mdi-filter-menu</v-icon
                        >
                      </template>
                      <span>Filters</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Company Search Filters</span>
                    </v-card-title>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-combobox
                            v-model="sortbyfield"
                            :items="sortbyfields"
                            label="Sort By"
                            multiple
                            outlined
                            dense
                            clearable
                          ></v-combobox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-combobox
                            v-model="statusfield"
                            :items="statusfields"
                            label="Filter Status"
                            multiple
                            outlined
                            dense
                            clearable
                          ></v-combobox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-combobox
                            v-model="attributefield"
                            :items="attributefields"
                            label="Filter Attribute"
                            multiple
                            outlined
                            dense
                            clearable
                          ></v-combobox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-combobox
                            v-model="typefield"
                            :items="typefields"
                            label="Filter Type"
                            multiple
                            outlined
                            dense
                            clearable
                          ></v-combobox>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menufrom"
                            v-model="menufrom"
                            :close-on-content-click="false"
                            :return-value.sync="datefrom"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="datefrom"
                                label="From Renewal"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="datefrom"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menufrom.save('')"
                              >
                                Clear
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menufrom.save(datefrom)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menuto"
                            v-model="menuto"
                            :close-on-content-click="false"
                            :return-value.sync="dateto"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="dateto"
                                label="To Renewal"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateto" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menuto.save('')"
                              >
                                Clear
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menuto.save(dateto)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container>

                    <v-card-actions>
                      <v-btn color="blue darken-1" text @click="refreshlist">
                        Done
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      @click="exportlist(1)"
                      medium
                      color="green darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-domain
                    </v-icon>
                  </template>
                  <span>Export Companies</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      @click="exportlist(2)"
                      medium
                      color="blue darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-account-multiple
                    </v-icon>
                  </template>
                  <span>Export Companies with Audiences</span>
                </v-tooltip>
              </div>
            </v-flex>
          </v-row>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Confirm from "@/components/Confirm";
export default {
  components: { Confirm },
  data() {
    return {
      loadformfields: true,
      companysearch: "",
      PageTitle: "Search " + localStorage.getItem("CURPROFILE") + " Companies",
      companies: [],
      sortbyfields: ["Company Name", "Status", "Attribute", "Type", "Renewal"],
      statusfields: [
        "Active",
        "Suspended",
        "Cancelled",
        "Prospect",
        "Prospect Act",
      ],
      attributefields: [],
      typefields: [],
      formfields: [],
      filterdialog: false,
      exportb64: "",
    };
  },

  computed: {
    headers() {
      return [
        { text: "Company Name", value: "Company_Name" },
        { text: "Code", value: "Company_Code" },
        { text: "Status", value: "Company_Status" },
        { text: "Attribute", value: "Acc_Attribute" },
        { text: "Type", value: "Acc_Type" },
        { text: "Renewal", value: "Renewal_Date" },
      ];
    },
  },

  created() {
    this.refreshlist();
  },

  methods: {
    async refreshlist() {
      this.filterdialog = false;
      this.companies = [];
      this.progressBar = true;
      this.myJsonResp = await this.PostData(
        "CompaniesList",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          loadformfields: this.loadformfields,
          companysearch: this.companysearch,
          sortbyfield: this.sortbyfield,
          statusfield: this.statusfield,
          attributefield: this.attributefield,
          typefield: this.typefield,
          datefrom: this.datefrom,
          dateto: this.dateto,
        })
      );

      this.progressBar = false;
      if (this.myJsonResp != "ERROR") {
        this.loadformfields = false;
        this.data = JSON.parse(this.myJsonResp);
        this.PageTitle =
          "Search " +
          localStorage.getItem("CURPROFILE") +
          " Companies - " +
          this.data["ResultCount"] +
          " Results ";
        this.companies = this.data["COMPANIES"];
        this.attributefields = this.data["ATTRIBUTES"];
        this.typefields = this.data["TYPES"];
        this.formfields = JSON.parse(this.data["FORMFIELDS"]);
        this.companysearch = this.formfields["companysearch"];
        this.sortbyfield = this.formfields["sortbyfield"];
        this.statusfield = this.formfields["statusfield"];
        this.attributefield = this.formfields["attributefield"];
        this.typefield = this.formfields["typefield"];
        this.datefrom = this.formfields["datefrom"];
        this.dateto = this.formfields["dateto"];
      }
    },

    async exportlist(extype) {
      this.filterdialog = false;
      this.progressBar = true;
      this.myJsonResp = await this.PostData(
        "CompaniesList",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          exportlist: Boolean(1),
          exporttype: extype,
          loadformfields: this.loadformfields,
          companysearch: this.companysearch,
          sortbyfield: this.sortbyfield,
          statusfield: this.statusfield,
          attributefield: this.attributefield,
          typefield: this.typefield,
          datefrom: this.datefrom,
          dateto: this.dateto,
        })
      );

      this.progressBar = false;
      if (this.myJsonResp != "ERROR") {
        this.loadformfields = false;
        this.data = JSON.parse(this.myJsonResp);
        this.exportb64 = atob(this.data["EXPORTB64"]);
        // Used npm install file-saver --save
        // https://github.com/eligrey/FileSaver.js/

        var FileSaver = require("file-saver");
        var blob = new Blob([this.exportb64], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        FileSaver.saveAs(
          blob,
          localStorage.getItem("CURPROFILE") + "_Export.csv"
        );

}
    },

    gotocompany(row) {
      this.$router.push("/Company/" + row.Company_ID);
    },
  },
};
</script>
